//libs
import React from 'react';

//constants
import { MONTHS } from 'shared/ui-components/ProductVariant/constants';

//styles
import { TextContainer } from './styles';

interface CouponValidityProps {
  expiryEpoch: number;
}
const VALIDITY = 'Validity:';

const ValidityText = ({ expiryEpoch }: CouponValidityProps) => {
  const expiryDate = new Date(expiryEpoch * 1000);
  const day = expiryDate.getDate();
  const month = MONTHS[expiryDate.getMonth()];
  const year = expiryDate.getFullYear();
  const dateSuffix = () => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };
  return (
    <TextContainer data-test="coupon-validity">
      {VALIDITY} {day}
      {dateSuffix()} {month} {year}{' '}
    </TextContainer>
  );
};

export default ValidityText;
